import React from 'react';
import intl from 'react-intl-universal';
import { withRouter } from 'react-router-dom';
import Autosuggest from 'react-autosuggest';
import PackActions from '../actions/PackActions';
import AuthStore from '../stores/AuthStore';
import CodeStore from '../stores/CodeStore';
import StateStore from '../stores/StateStore';
import ProductSuggestions from './ProductSuggestions';

function getSuggestionValue(suggestion) {
  return suggestion
}
function renderSuggestion(suggestion) {
  return (
    <span>{suggestion}</span>
  )
}

class ScanProductComponent extends React.Component {

  constructor() {
    super()
    this.state = {
      kod: '',
      order: false,
      config: AuthStore.getConfig(),
      suggestions: [],
      allSuggestions: []
    }
    this.lastRequestId = null
    this.onCodeChange = this.onCodeChange.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleKey = this.handleKey.bind(this)
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this)
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this)
  }

  componentWillMount() {
    CodeStore.addChangeListener(this.onCodeChange);
  }

  componentDidMount() {
    document.getElementById('kod').focus()
  }

  onCodeChange = () => {
    this.setState({
      allSuggestions: CodeStore.getCodes()
    })
  }

  handleChange = (event, { newValue }) => {
    this.setState({
      kod: newValue
    })
  }

  handleKey(event) {
    if (event.which == 13) {
      this.handleSubmit(event)
    }
  }

  deselectPack() {
    PackActions.selectPack(false)
  }

  handleSubmit(event) {
    event.preventDefault()
    let kod = document.getElementById('kod').value
    if (kod){
      document.querySelector('[type="submit"]').disabled = true
      PackActions.getVariants(kod, AuthStore.getUser().id, AuthStore.getPakowalnia(), StateStore.getPack())
    }
  }

  getSuggestions(value) {
    const inputValue = value.trim().toLowerCase()
    const inputLength = inputValue.length
    const {allSuggestions} = this.state

    return inputLength === 0 ? [] : allSuggestions.filter(code =>
      code.toLowerCase().slice(0, inputLength) === inputValue
    )
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    })
  }

  render() {
    const { kod, suggestions } = this.state
    const inputProps = {
      value: kod,
      onChange: this.handleChange,
      onKeyPress: this.handleKey,
      className: 'searchBox',
      id: 'kod',
      name: 'kod'
    }
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className="ramka center">
            <h4>{intl.get('Skanowanie kodu')}</h4>
              <label htmlFor="kod">{intl.get('Kod produktu')}: </label>
              <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps} />
              { this.state.error &&
                <div className="failed">
                  {intl.get('Nie znaleziono zamówienia dla produktu!')}'
                </div>
              }
          </div>
          <div className="buttons_wrap">
            { (this.state.config.wozek || !this.state.config.no_packages) &&
              <button className="pull-left" onClick={this.deselectPack}>{intl.get('Anuluj')}</button>
            }
            <input type="submit" className="pull-right" value={intl.get('Dalej')} />
          </div>
          <ProductSuggestions visible={this.state.config.product_suggestions} parent={this}/>
        </form>
      </div>
    );
  }
}

export default withRouter(ScanProductComponent);



// WEBPACK FOOTER //
// ./src/components/ScanProduct.js